import { tickerItems } from '@/mocks/homeData';

export default function TopTicker() {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <div className="w-full border-b border-primary-800/40 bg-primary-950 text-background-50">
      <div className="mx-auto flex h-11 max-w-[1440px] items-stretch px-4 md:px-8">
        {/* 固定标签 */}
        <div className="flex shrink-0 items-center gap-2 pr-4">
          <span className="relative flex h-2.5 w-2.5 items-center justify-center">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-400 opacity-70"></span>
            <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-accent-400"></span>
          </span>
          <span className="font-label text-xs font-bold tracking-[0.2em] text-accent-200">实时更新</span>
        </div>

        <div className="hidden w-px shrink-0 bg-background-50/20 md:block"></div>

        {/* 滚动更新条 */}
        <div className="relative flex-1 overflow-hidden">
          <div className="ticker-track h-11 items-center gap-10 pl-4 md:pl-6">
            {loop.map((item, idx) => (
              <a
                key={`${item.id}-${idx}`}
                href="#hot-wall"
                className="group flex shrink-0 cursor-pointer items-center gap-2 whitespace-nowrap font-label text-xs text-background-50/85 transition-colors hover:text-accent-200 md:text-sm"
              >
                <span className="font-mono text-[11px] text-background-50/50">{item.time}</span>
                {item.hot && (
                  <span className="rounded-sm bg-accent-500 px-1.5 py-px font-label text-[10px] font-bold leading-tight text-secondary-950">
                    热
                  </span>
                )}
                <span className="group-hover:underline">{item.text}</span>
              </a>
            ))}
          </div>
          <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-primary-950 to-transparent"></div>
        </div>
      </div>
    </div>
  );
}